import {Type} from "class-transformer";

export class HelpModel {
  Id: string;
  Title: string;
  Key: string;
  Value: string;
  @Type(() => Date)
  UserVersionModifiedDate: Date;
  @Type(() => Date)
  CoreVersionModifiedDate: Date;
  NeedsUpdate: boolean;
}
